import React from 'react'

function CreativeInspiration() {
    return (
        <div>CreativeInspiration</div>
    )
}

export default CreativeInspiration
